/***********************************************************************
 Controller class for user dependent data stored in a local storage
 ***********************************************************************/

import {LoggingService} from "logging/LoggingService";

const
    storageId = "localstorage",
    storage = supportsHtml5Storage() ? window.localStorage : null;

function supportsHtml5Storage() {
    try {
        return "localStorage" in window && window["localStorage"] !== null;
    }
    catch(e) {
        return false;
    }
}

function read() {

    if( !supportsHtml5Storage() ) {
        throw new Error("Browser does not support localStorage");
    }

    let resultMap = new Map();
    for ( let i = 0, len = storage.length; i < len; ++i ) {
        let key = storage.key( i );
        let value = storage.getItem( key );

        try{
            const localStorageValue = JSON.parse( value );
            resultMap.set( key, mapEntry( localStorageValue ) );
        }
        catch (e) {
            LoggingService.log( "local storage value '" + value + "' is not a valid JSON string!" );
        }
    }

    return resultMap;
}

function mapEntry( localStorageValue ) {
    return {
            score : Math.round( localStorageValue.stage.default.score_scaled * 100 ),
            lessonStatus : localStorageValue.stage.default.completion_status,
            lessonLocation : localStorageValue.stage.default.lesson_location
    };
}


// revealing public api
export const LocalStorageDataReader = {
    // public api for config

    /**
     * Gets the storage method for the course.
     *
     * @returns {String} "localstorage"
     */
    getStorageMethod : function() {
        return storageId;
    },

    read : read
};
